import React, {Component} from 'react';
import {Card, Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import CardDash from "../../components/extras/CardDash";
import localDB from "../../data/localDB";

class ServicesDash extends Component {
    constructor() {
        super();
        this.state = {
            cards: []
        };
    }

    componentDidMount() {
        this.itemsMenu();
    }

    itemsMenu() {
        let menu = localDB.get('menu');
        let cards = menu.filter(menu => menu.type === 'services').map(item => {
            return (
                <CardDash {...item} key={item.url}/>
            )
        });
        this.setState({cards});
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Servicios - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Servicios</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    {this.state.cards}
                </Card.Group>
            </div>
        );
    }
}

export default ServicesDash;



// WEBPACK FOOTER //
// ./src/containers/services/ServicesDash.js